import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// UI Libraries
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Button from "react-bootstrap/lib/Button";

// Actions
import getPaymentDetails from "./actions/GetPaymentDetails";
import makePayment from "./actions/MakePayment";
import changeLanguage from "MODULES/App/actions/ChangeLanguage";
import { PaymentMethodConst } from "./PayerConstants";
import makePaymentForCyberSource from "./actions/MakePaymentForCyberSource";
// Messages
// Strings
import {getBrowserName} from "UTILS/commonUtiltyFunctions";
import { Strings, ChangeLanguage } from "INTL/i18n";
import "./Payer.less";
import "./Payer.css";
import PaymentBase from "./PaymentBase";
import KNET_Logo from "../../resources/images/KNET-Logo.svg";
import MasterCard_VisaCard_Logo from "../../resources/images/MasterCard-VisaCard.svg";
import Default_Logo from "../../resources/images/default_payment.png";
import {PageView, initGA} from "MODULES/Tracking";
import { GOOGLE_ANALYTICS } from "CONSTANTS/AppConstants";

export class PaymentConfirmation extends PaymentBase {
  constructor(props) {
    super(props);
    this.toastId = null;
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.isMac = (navigator.userAgent.indexOf("Mac") !== -1) ? true : false;
    this.isiPhone = (navigator.userAgent.indexOf("like Mac") !== -1) ? true : false;
    this.state = {
      token: "",
      paymentDetails: null,
      errorMessage: "",
      paymentURLDetails: null,
      redirect: false,
      paymentGatewayName: "",
    };
  }
  componentDidMount() {
    initGA(GOOGLE_ANALYTICS.TRACKING_ID);
    PageView();
    let location = this.props.location.pathname.lastIndexOf("/");
    let token = location
      ? this.props.location.pathname.substring(location + 1)
      : "";

    this.updateLanguageFromUrl();
    this.setState({
      token: token,
    });
    token !== "" &&
      this.props.getPaymentDetailsAction(
        token,
        this.getPaymentDetailsActionCallback
      );
  }
  /**
   * This method is used to translate to given language specified in the url path
   */
  updateLanguageFromUrl = () => {
    //extract the language code from url
    let searchQueryString = window.location.hash.split("?")[1];
    let urlParams = new URLSearchParams(searchQueryString);
    let languageCode = urlParams.get("lang");
    ChangeLanguage(languageCode);
    this.props.changeLanguageInState(languageCode);
  };

  getPaymentDetailsActionCallback = (errorMessage, responseData) => {
    //  <Redirect  to="http://hello.com" />
    // window.location.href = "https://www.example.com";

    if (errorMessage === "") {
      if (!responseData.data) {
        // this.setState({redirect:true,paymentURLDetails:responseData.msg})
      } else {
        let data = responseData.data;
        if (responseData) {
          this.setState({
            paymentDetails: data,
          });

          this.setState({
            paymentGatewayName: this.state.paymentDetails.paymentGateways[0]
              .code,
          });
        }
      }
    } else {
      if (!navigator.onLine) errorMessage = "No network connection.";
      this.setState({
        errorMessage: errorMessage,
      });
    }
  };
  /* Handle on click of confirm button */
  onClickConfirmButton = () => {
    this.props.makePaymentAction(
      this.state.token,
      this.state.paymentGatewayName,
      this.makePaymentActionCallback
    );
  };
  /* Handle response of make payment action */
  makePaymentActionCallback = (errorMessage, responseData) => {
    if (errorMessage === "") {
      if (responseData.data) {
        let data = responseData.data;
        if (responseData.data.params) {
          this.props.makePaymentForCyberSourceGatewayAction(
            data.paymentUrl,
            data.params,
            this.makePaymentForCyberSourceGatewayActionCallback
          );
        } else {
          this.setState({
            paymentURLDetails: data.paymentUrl,
            redirect: true,
          });
        }
      }
      // else
      // {
      //   this.setState({
      //     paymentURLDetails: responseData.msg,
      //     redirect: true
      //   });
      // }
    } else {
      if (!navigator.onLine) errorMessage = "No network connection.";
      this.setState({
        errorMessage: errorMessage,
      });
    }
  };
  /**
   * method to redirect user to cybersource billing page
   */
  makePaymentForCyberSourceGatewayActionCallback = (
    errorMessage,
    responseData
  ) => {
    this.setState({
      redirect: true,
      paymentURLDetails: "https://testsecureacceptance.cybersource.com/billing",
    });
  };

  /* Handle on change of payment gateway */
  onChangePaymentGateway = (e) => {
    this.setState({ paymentGatewayName: e.target.value });
  };
  /**
   * Method to render different payment gateway options
   */
  renderPayment() {
    var data = [];
    this.state.paymentDetails.paymentGateways.map((payment, index) => {
      let paymentMethodName = payment.name.toUpperCase();
      if (paymentMethodName.includes(PaymentMethodConst.KNET)) {
        data.push({
          code: payment.code,
          name: payment.name,
          subTitle: Strings("KNETSubTitle"),
          imagePath: KNET_Logo,
        });
      } else if (paymentMethodName.includes(PaymentMethodConst.Credit_Card)) {
        data.push({
          code: payment.code,
          name: Strings("CreditCard"),
          subTitle: Strings("CreditCardSubTitle"),
          imagePath: MasterCard_VisaCard_Logo,
        });
      } else {
        data.push({
          code: payment.code,
          name: payment.name,
          subTitle: Strings("unknown_payment"),
          imagePath: Default_Logo,
        });
      }
    });
    /**UI handle for mac safari browser */
    var flag = false
    var styleClass = "paymentLogoContainer"
    if (this.isMac && getBrowserName().includes("Safari")) {
      flag = true
      if (this.props.selectedLanguage === "ar") styleClass = "extraMarginRight paymentLogoContainer"
      else styleClass = "extraMarginLeft paymentLogoContainer"
    } else if (this.isiPhone) {
      flag = true;
      if (this.props.selectedLanguage === "ar") styleClass = "extraMarginRight paymentLogoContainer"
      else styleClass = "extraMarginLeft paymentLogoContainer"
    }
    return (
      <Row>
        {data.map((user, index) => (
          <Row className="payMethodContainer">
            <Col md={12} xs={12} className="payMethod">
              <Row>
                <Col
                  md={1} xs={1}
                  className={
                    this.props.selectedLanguage === "ar"
                      ? "paymentInputContainer noPaddingLeft"
                      : "paymentInputContainer noPaddingLeft"
                  }
                >
                  <input
                    name="radio"
                    className="inputPaymentRadio"
                    type="radio"
                    value={user.code}
                    onChange={this.onChangePaymentGateway}
                  ></input>
                </Col>
                <Col
                  md={flag?8:9} xs={flag?8:9}
                  className={
                    this.props.selectedLanguage === "ar"
                      ? "paymentTitleContainerAr noPadding"
                      : "paymentTitleContainer noPadding"
                  }
                >
                  <Row>
                    <Col
                      md={12} xs={12}
                      className="noPadding"
                    >
                      <label className="paymentTitle" for={user.code}>
                        {Strings(user.name)}
                      </label>
                    </Col>
                    <Col
                      md={12} xs={12}
                        className="noPadding"
                      >
                        <label className="paymentSubTitle">
                          {Strings(user.subTitle)}
                        </label>
                      </Col>
                  </Row>
                </Col>
                <Col md={2} xs={2} className={styleClass}>
                 <img
                      src={user.imagePath}
                      className="paymentLogo"
                      alt={user.name}
                      data-toggle="tooltip"
                    />
                  </Col>
              </Row>
            </Col>
          </Row>
        ))}
      </Row>
    );
  }
  rednerPayButton() {
    return (<Col md={12} xs={12} className="payButtonContainer" dir={"ltr"}>
    <Button
      className="payButton"
      onClick={() => {
        this.onClickConfirmButton();
        this.disabled = true;
      }}
      disabled={this.state.redirect}
    >
      {Strings("pay")}
    </Button>
  </Col>)
  }
  /**
   * Parent method to render payment gateway methods
   */
  renderPaymentGatewayMethods() {
    return (
      <Col
        md={6}
        mdOffset={this.props.selectedLanguage === "ar"?0:1}
        xs={12}
        className={this.isMobile?"payerMethodContainer":"payerMethodContainer  noPadding"}
      >
        <Row>
          <Col
            md={12}
            className={
              this.props.selectedLanguage === "ar"
                ? "payTitleLabelContainerAr"
                : "payTitleLabelContainer"
            }
          >
            <label className="payTitleLabel">{Strings("SelectMethod")}</label>
          </Col>
          <Col md={12} className="payMethodSuperContainer">
            {this.renderPayment()}
          </Col>
          {this.rednerPayButton()}
        </Row>
      </Col>
    );
  }
  /**
   * Method to render Summary component
   */
  renderSummary() {
    /**UI handle for mac safari browser */
    var flag = false
    var styleClass = "LabelValueContainer"
    if (this.isMac && getBrowserName().includes("Safari")) {
      flag = true
      if (this.props.selectedLanguage === "ar") styleClass = "extraMarginRightForValue LabelValueContainer"
      else styleClass = "extraMarginLeft LabelValueContainer"
    } else if (this.isiPhone) {
      flag = true;
      if (this.props.selectedLanguage === "ar") styleClass = "extraMarginRight LabelValueContainer"
      else styleClass = "extraMarginLeft LabelValueContainer"
    }
    /** */
    return (
      <Col
        md={3} xs={12}
        className="payerSummaryConatiner"
        mdOffset={this.props.selectedLanguage === "ar" ? 1 :0}
      >
        <Row>
          <Col
            md={12} xs={12}
            className={
              this.props.selectedLanguage === "ar"
                ? "payerSummaryTitleContainerAr"
                : "payerSummaryTitleContainer"
            }
          >
            <label className="payerSummaryTitle">
              {Strings("OrderSummary")}
            </label>
          </Col>
          <Col md={12} xs={12} className="cardStyles">
            <Row
              className="d-flex justify-content-center"
            >
              <Col md={12} xs={12} className="noPadding">
                <Row className="paymentDetailsTitle">
                  <Col
                    md={flag?5:6} xs={flag?5:6}
                    className={
                      this.props.selectedLanguage === "ar"
                        ? "LabelContainerAr"
                        : "LabelContainer"
                    }
                  >
                    <label className="totlePriceLabel">
                      {Strings("TotalPrice")}
                    </label>
                  </Col>
                  <Col
                    md={this.props.selectedLanguage === "ar" ? 6 : 4}
                    xs={6}
                    mdOffset={this.props.selectedLanguage === "ar" ? 0 : 2}
                    className={styleClass}
                  >
                    <label className="LabelValue">
                      {this.state.paymentDetails.amount +
                        " " +
                        this.state.paymentDetails.currencySymbol}
                    </label>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row
              className="d-flex NotesContainer"
            >
              <Col
              md={12} xs={12}
              className={
                this.props.selectedLanguage === "ar" ? "notesAr" : "notes"
              }
              >
                <span className="Notes">
                  {this.state.paymentDetails.notes !== undefined
                    ? this.state.paymentDetails.notes
                    : Strings("notAvailable")}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  }

  render() {
    if (this.state.redirect) {
      window.location.replace(this.state.paymentURLDetails);
    }
    return (
      <div>
        {this.renderHeader(this.props.selectedLanguage)}
        <div className="App_body">
          <div className="payerContainer">
            {this.state.errorMessage !== ""
              ? this.renderErrorPage(this.state.errorMessage)
              : null}
            {this.state.paymentDetails && this.state.errorMessage === "" ? (
              <div>
                <Row
                  className={this.props.selectedLanguage === "ar"?"justify-content-end":""}
                >
                  {this.isMobile?(this.renderSummary()):null}
                  {this.renderPaymentGatewayMethods()}
                  {!this.isMobile?this.renderSummary():null}
                </Row>
                <Row >
                  <Col md={this.props.selectedLanguage === "ar" ? 11 : 6}
                    mdOffset={1} className="FutureContainer"
                    dir="ltr"
                  >
                    <label className="Powered-by">Powered by</label>
                    <label className="Future-Pay"> Future Pay</label>
                  </Col>
                </Row>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

PaymentConfirmation.propTypes = {
  selectedLanguage: PropTypes.string,
  aString: PropTypes.string,
  anObject: PropTypes.object,
  aFunc: PropTypes.func,
  aBool: PropTypes.bool,
  anArray: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    selectedLanguage: state.LanguageReducer.selectedLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPaymentDetailsAction: getPaymentDetails,
      makePaymentAction: makePayment,
      changeLanguageInState: changeLanguage,
      makePaymentForCyberSourceGatewayAction: makePaymentForCyberSource,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentConfirmation);



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentConfirmation.js